// // import React, { useEffect, useState, useRef } from "react";
// // import authApiService from "../../services/authServices";
// // import { Link } from "react-router-dom";

// // function InterSite() {
// //     // const [city, setCity] = useState([]);

// //     // useEffect(() => {
// //     //     const fetchCityData = async () => {
// //     //         try {
// //     //             const response = await authApiService.get("cityDetails");
// //     //             if (response && response.data) {
// //     //                 setCity(response.data);
// //     //                 // if no city is selected then
// //     //                 const storedCity = localStorage.getItem("selectedCity");
// //     //                 if (!storedCity && response.data.length > 0) {
// //     //                     const firstCity = response.data[0];
// //     //                     localStorage.setItem("selectedCity", JSON.stringify(firstCity));
// //     //                 }

// //     //             }
// //     //         } catch (error) {
// //     //             console.error("Error fetching city data:", error);
// //     //         }
// //     //     };

// //     //     fetchCityData();
// //     // }, []);

// //     // const handleCitySelect = (city) => {
// //     //     localStorage.setItem("selectedCity", JSON.stringify(city));
// //     // };
// //     const [city, setCity] = useState([]);
// //     const hasFetched = useRef(false);

// //     useEffect(() => {
// //         if (hasFetched.current) return; 
// //         hasFetched.current = true;

// //         const storedCities = localStorage.getItem("cityList");
// //         const storedSelectedCity = localStorage.getItem("selectedCity");

// //         if (storedCities) {
// //             const parsedCities = JSON.parse(storedCities);
// //             setCity(parsedCities);

// //             if (!storedSelectedCity && parsedCities.length > 0) {
// //                 localStorage.setItem("selectedCity", JSON.stringify(parsedCities[0]));
// //             }
// //         } else {
// //             const fetchCityData = async () => {
// //                 try {
// //                     const response = await authApiService.get("cityDetails");
// //                     console.log("CityDetails", response)
// //                     if (response && response.data) {
// //                         console.log("Fetched cityDetails from API:", response.data);
// //                         setCity(response.data);
// //                         localStorage.setItem("cityList", JSON.stringify(response.data));

// //                         if (!storedSelectedCity && response.data.length > 0) {
// //                             localStorage.setItem("selectedCity", JSON.stringify(response.data[0]));
// //                         }
// //                     }
// //                 } catch (error) {
// //                     console.error("Error fetching city data:", error);
// //                 }
// //             };

// //             fetchCityData();
// //         }
// //     }, []);

// //     const handleCitySelect = (city) => {
// //         localStorage.setItem("selectedCity", JSON.stringify(city));
// //     };

// //     return (
// //         <div id="enter-box" style={{ display: 'none' }}>
// //             <p className="par-txt">
// //                 To enter City Tennis League, please choose the city you'd like to view from the list below:
// //             </p>
// //             <ul id="enter-city" className="submenu flt">
// //                 {city && city.map((cityItem) => (
// //                     <li key={cityItem.id}>
// //                         <Link
// //                             style={{
// //                                 width: "360px",
// //                                 opacity: 1,
// //                                 overflow: "hidden",
// //                             }}
// //                             to="carter/home"
// //                             onClick={() => handleCitySelect({ id: cityItem.id, name: cityItem.name })}
// //                         >
// //                             {cityItem.name}
// //                         </Link>
// //                     </li>
// //                 ))}
// //             </ul>
// //         </div>
// //     );
// // }

// // export default InterSite;




// import React, { useEffect, useState, useRef } from "react";
// import authApiService from "../../services/authServices";
// import { Link } from "react-router-dom";

// function InterSite() {
//     const [city, setCity] = useState([]);
//     const hasFetched = useRef(false);

//     useEffect(() => {
//         if (hasFetched.current) return;
//         hasFetched.current = true;

//         const fetchCityData = async () => {
//             try {
//                 const response = await authApiService.get("cityDetails");
//                 console.log("CityDetails", response);

//                 if (response && response.data) {
//                     setCity(response.data);
//                     localStorage.setItem("cityList", JSON.stringify(response.data));

//                     const storedSelectedCity = localStorage.getItem("selectedCity");
//                     if (!storedSelectedCity && response.data.length > 0) {
//                         localStorage.setItem("selectedCity", JSON.stringify(response.data[0]));
//                     }
//                 }
//             } catch (error) {
//                 console.error("Error fetching city data:", error);
//             }
//         };

//         fetchCityData();
//     }, []);

//     const handleCitySelect = (city) => {
//         localStorage.setItem("selectedCity", JSON.stringify(city));
//     };

//     return (
//         <div id="enter-box" style={{ display: 'none' }}>
//             <p className="par-txt">
//                 To enter City Tennis League, please choose the city you'd like to view from the list below:
//             </p>
//             <ul id="enter-city" className="submenu flt">
//                 {city && city.map((cityItem) => (
//                     <li key={cityItem.id}>
//                         <Link
//                             style={{
//                                 width: "360px",
//                                 opacity: 1,
//                                 overflow: "hidden",
//                             }}
//                             to="carter/home"
//                             onClick={() => handleCitySelect({ id: cityItem.id, name: cityItem.name })}
//                         >
//                             {cityItem.name}
//                         </Link>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }

// export default InterSite;



// import React, { useEffect, useState, useRef } from "react";
// import authApiService from "../../services/authServices";
// import { Link } from "react-router-dom";

// function InterSite() {
//     // const [city, setCity] = useState([]);

//     // useEffect(() => {
//     //     const fetchCityData = async () => {
//     //         try {
//     //             const response = await authApiService.get("cityDetails");
//     //             if (response && response.data) {
//     //                 setCity(response.data);
//     //                 // if no city is selected then
//     //                 const storedCity = localStorage.getItem("selectedCity");
//     //                 if (!storedCity && response.data.length > 0) {
//     //                     const firstCity = response.data[0];
//     //                     localStorage.setItem("selectedCity", JSON.stringify(firstCity));
//     //                 }

//     //             }
//     //         } catch (error) {
//     //             console.error("Error fetching city data:", error);
//     //         }
//     //     };

//     //     fetchCityData();
//     // }, []);

//     // const handleCitySelect = (city) => {
//     //     localStorage.setItem("selectedCity", JSON.stringify(city));
//     // };
//     const [city, setCity] = useState([]);
//     const hasFetched = useRef(false);

//     useEffect(() => {
//         if (hasFetched.current) return; 
//         hasFetched.current = true;

//         const storedCities = localStorage.getItem("cityList");
//         const storedSelectedCity = localStorage.getItem("selectedCity");

//         if (storedCities) {
//             const parsedCities = JSON.parse(storedCities);
//             setCity(parsedCities);

//             if (!storedSelectedCity && parsedCities.length > 0) {
//                 localStorage.setItem("selectedCity", JSON.stringify(parsedCities[0]));
//             }
//         } else {
//             const fetchCityData = async () => {
//                 try {
//                     const response = await authApiService.get("cityDetails");
//                     console.log("CityDetails", response)
//                     if (response && response.data) {
//                         console.log("Fetched cityDetails from API:", response.data);
//                         setCity(response.data);
//                         localStorage.setItem("cityList", JSON.stringify(response.data));

//                         if (!storedSelectedCity && response.data.length > 0) {
//                             localStorage.setItem("selectedCity", JSON.stringify(response.data[0]));
//                         }
//                     }
//                 } catch (error) {
//                     console.error("Error fetching city data:", error);
//                 }
//             };

//             fetchCityData();
//         }
//     }, []);

//     const handleCitySelect = (city) => {
//         localStorage.setItem("selectedCity", JSON.stringify(city));
//     };

//     return (
//         <div id="enter-box" style={{ display: 'none' }}>
//             <p className="par-txt">
//                 To enter City Tennis League, please choose the city you'd like to view from the list below:
//             </p>
//             <ul id="enter-city" className="submenu flt">
//                 {city && city.map((cityItem) => (
//                     <li key={cityItem.id}>
//                         <Link
//                             style={{
//                                 width: "360px",
//                                 opacity: 1,
//                                 overflow: "hidden",
//                             }}
//                             to="carter/home"
//                             onClick={() => handleCitySelect({ id: cityItem.id, name: cityItem.name })}
//                         >
//                             {cityItem.name}
//                         </Link>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }

// export default InterSite;




import React, { useEffect, useState, useRef } from "react";
import authApiService from "../../services/authServices";
import { Link } from "react-router-dom";

function InterSite() {
    const [city, setCity] = useState([]);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        const fetchCityData = async () => {
            try {
                const response = await authApiService.get("cityDetails");
                console.log("CityDetails", response);

                if (response && response.data) {
                    const sortedCities = [...response.data].sort((a, b) =>
                        String(a?.name || "").localeCompare(String(b?.name || ""), undefined, { sensitivity: "base" })
                    );
                    setCity(sortedCities);
                    localStorage.setItem("cityList", JSON.stringify(sortedCities));

                    const storedSelectedCity = localStorage.getItem("selectedCity");
                    // Only set default city if no city is selected AND user is not logged in
                    const accessToken = localStorage.getItem("accessToken");
                    if (!storedSelectedCity && !accessToken && sortedCities.length > 0) {
                        localStorage.setItem("selectedCity", JSON.stringify(sortedCities[0]));
                    }
                }
            } catch (error) {
                console.error("Error fetching city data:", error);
            }
        };

        fetchCityData();
    }, []);

    const handleCitySelect = (cityObj) => {
        localStorage.setItem("selectedCity", JSON.stringify(cityObj));
        window.dispatchEvent(new Event("cityChange"));
    };

    return (
        <div id="enter-box" style={{ display: 'none' }}>
            <p className="par-txt">
                To enter City Tennis League, please choose the city you'd like to view from the list below:
            </p>
            <ul id="enter-city" className="submenu flt">
                {city && city.map((cityItem) => (
                    <li key={cityItem.id}>
                        <Link
                            style={{
                                width: "360px",
                                opacity: 1,
                                overflow: "hidden",
                            }}
                            to="carter/home"
                            onClick={() => handleCitySelect({ id: cityItem.id, name: cityItem.name })}
                        >
                            {cityItem.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default InterSite;
